// extracted by mini-css-extract-plugin
module.exports = {"outer_container":"BacklogChart_outer_container__3hnrD","width":"BacklogChart_width__1bxSy"};